(ns quuppa.peweb.peinfo-utils
  (:require [clojure.string :as str]))

(defn update-address
  "Adds a scheme to the address if missing. Adds a default path if the path is empty or '/'."
  [address scheme default-web-path]
  (let [address (if (and address
                         (not (str/includes? address "://")))
                  (str scheme "://" address)
                  address)
        url (try
              (js/URL. address)
              (catch js/Error _ nil))]
    (if (and url
             (or (empty? (.-pathname url))
                 (and (= (.-pathname url) "/")
                      (not (str/ends-with? address "/")))))
      (str (str/replace address #"/?$" "") default-web-path)
      address)))

(defn filter-output-data-files [search-string all-files]
  (if (str/blank? search-string)
    all-files
    (let [search (str/lower-case search-string)]
      (filter
        (fn [{:keys [filename-lc]}]
          (and filename-lc
               (str/includes? filename-lc search)))
        all-files))))

(defn safe-empty?
  "Like empty? but safe for any value the QPE might send.
   Returns true for nil, blank strings, and empty collections.
   Does NOT throw on non-seqable values such as keywords."
  [v]
  (or (nil? v)
      (and (string? v) (str/blank? v))
      (and (coll? v) (not (seq v)))
      (and (number? v) (< (Math/abs v) 1e-10))))

(defn safe-empty-without-number-check?
  "Like empty? but safe for any value the QPE might send.
   Returns true for nil, blank strings, and empty collections.
   Does NOT throw on non-seqable values such as keywords."
  [v]
  (or (nil? v)
      (and (string? v) (str/blank? v))
      (and (coll? v) (not (seq v)))))
